import React, { useState, useEffect } from 'react';
import './StatusModal.css';

// Admin status options
const adminStatusOptions = [
  'Sin Estado',
  'Laboratorio En Trámite',
  'Solicitar Turno Para Laboratorio',
  'Gestionar Turno Para Visita',
  'Solicito Reagendar Turno',
  'Turno Asignado',
  'Turno Confirmado',
  'Asistio Al Turno',
  'No Desea Participar',
  'Baja',
  'Cancela Turno'
];

// Regular user status options
const userStatusOptions = [
  'Sin Estado',
  'No Desea Participar',
  'Turno Asignado',
  'Turno Confirmado',
  'Cancela Turno',
  'Baja'
];

// Get status options based on user role
const getStatusOptions = () => {
  const userRole = localStorage.getItem('userRole');
  return userRole === 'admin' ? adminStatusOptions : userStatusOptions;
};

const StatusModal = ({ isOpen, onClose, onSave, currentStatus, dni, selectedItem = {} }) => {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  // Update selectedStatus and selectedDate when props change
  useEffect(() => {
    // Reset to first available option if currentStatus is not in the available options
    const availableOptions = getStatusOptions();
    if (currentStatus && !availableOptions.includes(currentStatus)) {
      setSelectedStatus('');
    } else {
      setSelectedStatus(currentStatus || '');
    }
    
    // If there's a selectedItem with a date, format it for the date input (YYYY-MM-DD)
    if (selectedItem?.fechaSeleccionada) {
      const date = new Date(selectedItem.fechaSeleccionada);
      const formattedDate = date.toISOString().split('T')[0];
      setSelectedDate(formattedDate);
    } else {
      setSelectedDate('');
    }
  }, [currentStatus, selectedItem]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedStatus) {
      setError('Por favor selecciona un estado');
      return;
    }
    
    setError(null);
    setIsSaving(true);
    
    try {
      // Format the date to ISO string if it exists
      let formattedDate = selectedDate;
      if (selectedDate) {
        // Ensure the date is in the correct format (YYYY-MM-DD)
        const date = new Date(selectedDate);
        if (!isNaN(date.getTime())) {
          formattedDate = date.toISOString().split('T')[0];
        }
      }
      
      await onSave(dni, selectedStatus, formattedDate || '');
      onClose();
    } catch (error) {
      console.error('Error updating status:', error);
      setError(error.message || 'Error al actualizar el estado. Por favor, intente nuevamente.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="status-modal">
        <h3>Editar Paciente</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="status">Estado:</label>
            <select
              id="status"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="status-select"
              required
            >
              <option value="">Seleccione un estado</option>
              {getStatusOptions().map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="fechaSeleccionada">Fecha Seleccionada:</label>
            <input
              type="date"
              id="fechaSeleccionada"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="date-input"
            />
          </div>
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-cancel"
              disabled={isSaving}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-save"
              disabled={isSaving}
            >
              {isSaving ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StatusModal;
